import APIService from './APIService'

const api = APIService()

export const fetchImportJobs = payload => api.get(`jobs/results${payload.query}`)
export const fetchPendingImportJobs = () => api.get(`jobs/pending`)
